import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { forwardRef, useContext } from 'react';
import ReactDOM from 'react-dom';
import { StylesContext } from 'ricos-styles';
import type { TextDirection } from 'ricos-types';
import { isSSR } from 'wix-rich-content-common';

interface Props {
  className?: string;
  container?: HTMLElement;
  children?: ReactNode;
  languageDir?: TextDirection;
  zIndex?: number;
}

const RicosPortal = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { portalCssVars, stylePreset } = useContext(StylesContext);

  return (
    <div
      dir={props?.languageDir}
      ref={ref}
      data-hook="ricos-portal"
      className={classNames(props?.className, stylePreset)}
      style={portalCssVars}
    >
      {props?.children}
    </div>
  );
});

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  if (!isSSR()) {
    const container = props?.container ?? document?.body;
    return ReactDOM.createPortal(<RicosPortal {...props} ref={ref} />, container);
  }
  return <RicosPortal {...props} ref={ref} />;
});
